var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,10.3c0.2-0.8,0.7-1.4,1.2-2C2,7.3,3,6.4,4,5.6c0.1-0.1,0.1-0.2,0-0.3C3.7,5,3.4,4.7,3.1,4.4 C2.7,4,2.7,3.4,3.1,3.1C3.5,2.7,4,2.7,4.4,3.1c3.3,3.3,6.6,6.6,9.9,9.9c1.7,1.7,3.5,3.5,5.2,5.2c0.3,0.3,0.4,0.5,0.4,0.9 c-0.1,0.4-0.3,0.6-0.6,0.7c-0.4,0.1-0.7,0-0.9-0.2c-0.6-0.6-1.1-1.1-1.7-1.7c-0.1-0.1-0.2-0.2-0.4-0.1c-1.5,0.5-3,0.8-4.6,0.7 c-2.3-0.1-4.5-0.7-6.5-1.9c-1.9-1.1-3.5-2.6-4.7-4.5c-0.2-0.3-0.4-0.7-0.5-1C0,10.9,0,10.6,0,10.3z M12,16.7c1,0,1.9-0.1,2.8-0.4 c0.2-0.1,0.2-0.1,0.1-0.2c-0.4-0.4-0.9-0.9-1.3-1.3c-0.1-0.1-0.2-0.1-0.4-0.1c-0.6,0.2-1.3,0.2-2,0.1C8.7,14.4,7.3,12,8,9.5 c0-0.1,0-0.2-0.1-0.3C7.2,8.5,6.4,7.7,5.7,7c-0.1-0.1-0.2-0.1-0.4,0C4,7.9,2.9,9,2,10.3c-0.2,0.3-0.2,0.5,0,0.9 c0.7,1,1.5,1.9,2.5,2.7C6.6,15.7,9.1,16.7,12,16.7z M11.7,13.1c-0.7-0.7-1.3-1.4-2-2C9.6,12,10.8,13.1,11.7,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,11.2c-0.2,0.8-0.7,1.3-1.1,1.9c-0.8,1-1.8,1.9-2.8,2.8c-0.2,0.1-0.3,0.1-0.4,0c-0.3-0.3-0.6-0.6-0.9-0.9 c-0.1-0.1-0.1-0.2,0-0.3c1.2-0.9,2.3-1.9,3.2-3.2c0.1-0.1,0.1-0.2,0.2-0.2c0.2-0.3,0.2-0.5,0-0.8c-0.9-1.3-2-2.4-3.3-3.4 c-1.5-1.1-3.2-1.8-5.1-2.1c-1.5-0.2-3-0.2-4.5,0.2C9,5.2,8.9,5.1,8.8,5c-0.3-0.4-0.7-0.7-1-1C7.5,3.7,7.5,3.7,7.8,3.6 C8.7,3.3,9.6,3.1,10.6,3c1.9-0.2,3.8,0,5.7,0.7c2.4,0.8,4.4,2.2,6.1,4.1c0.4,0.4,0.7,0.8,1,1.3c0.3,0.4,0.5,0.8,0.6,1.3 C24,10.6,24,10.9,24,11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.2,10.8c0,0.4-0.1,0.8-0.2,1.2c-0.1,0.2-0.1,0.2-0.3,0.1c-0.4-0.4-0.9-0.9-1.3-1.3 c-0.1-0.1-0.1-0.2-0.1-0.3c-0.2-1-0.9-1.8-2-2c-0.1,0-0.2-0.1-0.3-0.2c-0.4-0.4-0.8-0.9-1.3-1.3c-0.2-0.2-0.2-0.2,0.1-0.3 c1.4-0.4,2.8-0.1,3.9,0.9C15.7,8.4,16.2,9.5,16.2,10.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.762044b16ef6476c7ad5024e9d97eea7.svg";
export { ForwardRef as ReactComponent };